// extracted by mini-css-extract-plugin
module.exports = {"emptyCart":"EmptyCart_emptyCart__61Uwn","text":"EmptyCart_text__O54qD","cofDesignV1":"EmptyCart_cofDesignV1__iqnoJ"};